<template>
  <Layout row p-5>
    <!--slot for a custom component, e.g. icon-->
    <slot></slot>
    <TextField disabled :default-value="defaultText" class="default-value" />
    <TextField :value.sync="translatedText" />
  </Layout>
</template>

<script>
import Layout from '@wizer/core/components/layout/Layout.vue'
import TextField from '@wizer/core/components/text-field/TextField.vue'
import { isNil } from 'lodash'
import { mapGetters } from 'vuex'

export default {
  name: 'TranslationEntry.vue',
  components: {
    Layout,
    TextField,
  },
  props: {
    defaultTranslation: String,
    selectedTranslation: String,
    resourceKey: String,
    languageId: String,
  },
  computed: {
    ...mapGetters('FormTranslation', ['getTranslationByLanguageId']),
    defaultText() {
      return this.defaultTranslation
    },
    translatedText: {
      get() {
        const storedTranslation = this.getTranslationByLanguageId(this.languageId, this.resourceKey)
        if (storedTranslation && !isNil(storedTranslation.translatedText)) {
          return storedTranslation.translatedText
        }
        return this.selectedTranslation
      },
      async set(translatedText) {
        await this.$store.dispatch('FormTranslation/add', {
          translatedText,
          languageId: this.languageId,
          resourceKey: this.resourceKey,
        })
      },
    },
  },
}
</script>

<style scoped></style>
